import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  name: z.string().min(1, t('pages.application_roster_group.components.schema.roster_group_schema_required')),
  show_stats: z.boolean().default(false),
  position_order: z.array(z.string()).default([]),
  sort_order: z.coerce.number().min(0).default(0),
  team_uuid: z.string().optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
